export default function MiniNumberCircle({ total }) {
  return (
    total > 0 && (
      <div
        style={{
          position: "absolute",
          right: 0,
          bottom: 0,
          fontSize: 12,
          color: "white",
          backgroundColor: "#373737",
          lineHeight: 1.6,
          width: 20,
          height: 20,
          textAlign: "center",
          borderRadius: 15,
        }}
      >
        {total}
      </div>
    )
  );
}
